// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { PasteArticlePresenter } from '../presenter/paste-article.presenter';
import { AlertHelper } from '@shared/alert/alert.helper';
import { MountingRailHelper } from '../../../helper/mounting-rail.helper';
import { BuildingBlockPasteArticleManager } from '../manager/building-block-paste-article.manager';
import { ArticleByTypeManager } from '@article/manager/article-by-type.manager';
import { UndoRedoHelper } from '@shared/undo/undo-redo.helper';
import { InsertArticleUtils } from '../util/insert-article-utils';
import { BlockingZoneArticleManagerFactory } from '../manager/blocking-zone-article-manager.factory';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { UndoRedoUtils } from '@shared/undo/undo-redo-utils';
import { InsertArticleHelperFactory } from '@article/helper/insert-article-helper.factory';
import { ProjectModel } from '../../../model/project.model';
import { ProjectArticleService } from '../../../service/project-article.service';
import { SelectionModelService } from './selection-model.service';
import { PasteArticleManager } from '../manager/paste-article.manager';
import { InsertArticleService } from './insert-article.service';
import { ProjectHelper } from '../../../helper/project.helper';
import { Observable, Subject } from 'rxjs';
import { ApplicationRefreshService } from '@services/application-refresh.service';
import { DetachArticleUsageService } from '@project/service/detach-article-usage.service';
import { ProjectComponentPresenter } from '../../project-component.presenter';

@Injectable({providedIn: 'root'})
export class PasteArticleService {

  private pasteArticlePresenter: PasteArticlePresenter;
  private isPasteOperationCalledByShortcut: boolean = false;
  private _pasteOperationCompleted$ = new Subject<boolean>();

  public get pasteOperationCompleted$(): Observable<boolean> {
    return this._pasteOperationCompleted$.asObservable();
  }

  constructor(
    alertHelper: AlertHelper,
    mountingRailHelper: MountingRailHelper,
    buildingBlockPasteArticleManager: BuildingBlockPasteArticleManager,
    articleByTypeManager: ArticleByTypeManager,
    undoRedoHelper: UndoRedoHelper,
    insertArticleUtils: InsertArticleUtils,
    blockingZoneArticleManagerFactory: BlockingZoneArticleManagerFactory,
    containerService: ContainerService,
    undoRedoUtils: UndoRedoUtils,
    insertArticleHelperFactory: InsertArticleHelperFactory,
    projectModel: ProjectModel,
    projectArticleService: ProjectArticleService,
    selectionModelService: SelectionModelService,
    private pasteArticleManager: PasteArticleManager,
    insertArticleService: InsertArticleService,
    applicationRefreshService: ApplicationRefreshService,
    detachArticleUsageService: DetachArticleUsageService,
    private projectHelper: ProjectHelper,
    private projectComponentPresenter: ProjectComponentPresenter,
  ) {
    this.pasteArticlePresenter = new PasteArticlePresenter(
      insertArticleUtils,
      alertHelper,
      projectModel,
      projectArticleService,
      mountingRailHelper,
      pasteArticleManager,
      buildingBlockPasteArticleManager,
      articleByTypeManager,
      selectionModelService,
      undoRedoHelper,
      blockingZoneArticleManagerFactory,
      containerService,
      undoRedoUtils,
      insertArticleHelperFactory,
      insertArticleService,
      applicationRefreshService,
      detachArticleUsageService
    );
    pasteArticleManager.pasteOperationCompleted$.subscribe(result => this.pasteOperationCompleted(result))
  }

  private async pasteOperationCompleted(data: boolean): Promise<void> {
    if (this.isPasteOperationCalledByShortcut) {
      await this.pasteArticlePresenter.pasteOperationCompletedHandler(data);
      this.isPasteOperationCalledByShortcut = false;
    }
    this._pasteOperationCompleted$.next(data);
  }

  public async pasteArticlesAfterEachSelectedTriggered(): Promise<void> {
    this.isPasteOperationCalledByShortcut = true;
    this.pasteArticlePresenter.isPasteOperation = true;
    const pasteOperationEnabled: boolean =
      this.projectHelper.isCopyPasteAllowed() &&
      this.pasteArticleManager.isPasteOperationAvailable() &&
      this.pasteArticlePresenter.selectedArticlesOnRailExist;
    if (pasteOperationEnabled) {
      await this.pasteArticlePresenter.executePasteOperation(PasteArticlePresenter.PASTE_AFTER_EACH_SELECTED_ARTICLE, 0);
    }
  }

  public pasteArticlesTriggered(): void {
    const pasteOperationEnabled: boolean = this.projectHelper.isCopyPasteAllowed() && this.pasteArticleManager.isPasteOperationAvailable();
    if (pasteOperationEnabled) {
      this.projectComponentPresenter.openPasteArticleDialog(null, null, true, false, true);
    }
  }
}
